{
    "access-denied.description": "Please contact us if you would like access",
    "access-denied.title": "Unfortunately, you do not have access here",
    "archive-assignment.confirmation-modal.description": "Are you sure you want to archive «{name}»?",
    "archive-assignment.confirmation-modal.labels.button.archive": "Archive {name}",
    "archive-assignment.confirmation-modal.title": "Archive assignment",
    "archive-customer.confirmation-modal.description": "Are you sure you want to archive {name}?\nArchived customers are not visible in the customer overview.\nBy using a filter you can still see your archived customers.",
    "archive-customer.confirmation-modal.description.monitoring": "The active screening will get cancelled by archiving a customer.\nAre you sure you want to archive {name}?\nArchived customers are not visible in the customer overview.\nBy using a filter you can still see your archived customers.",
    "archive-customer.confirmation-modal.labels.button.archive": "Archive {name}",
    "archive-customer.confirmation-modal.title": "Archive customer",
    "assignment.selector.error.message": "Choose an assignment",
    "attachments.actions.delete-attachment": "Remove document",
    "attachments.actions.delete-signed-attachment": "Remove signed document",
    "attachments.actions.download-attachment": "Download document",
    "attachments.actions.download-signed-attachment": "Download signed document",
    "attachments.actions.edit-signature": "Edit E-signatures",
    "attachments.actions.section.signed.document.title": "Signed document",
    "attachments.actions.signature.help-text": "E-signatures are only available for PDF files",
    "attachments.actions.view-signature": "View E-signatures",
    "attachments.cancel.confirmation.description": "Changes are not saved.\nBy canceling, the specified recipients will not be able to access document signing.",
    "attachments.cancel.confirmation.title": "Unsaved changes",
    "attachments.cancel.confirmation.yes": "Cancel and discard changes",
    "attachments.customer.upload.assignment.select": "Select where you want to put the document",
    "attachments.delete.confirmation.description": "Are you sure you want to delete the document: {name} ?",
    "attachments.delete.confirmation.signed.description": "Are you sure you want to delete signed document: {name}?\nSince this action cannot be undone, it is recommended to download it before deletion.",
    "attachments.delete.confirmation.signed.title": "Remove signed document",
    "attachments.delete.confirmation.signed.yes": "Remove signed document",
    "attachments.delete.confirmation.title": "Remove document",
    "attachments.delete.confirmation.yes": "Remove document",
    "attachments.labels.empty": "There are no uploaded documents",
    "attachments.labels.loading": "Loading...",
    "attachments.labels.signature-status.expired": "Expired",
    "attachments.labels.signature-status.not-activated": "(not activated)",
    "attachments.labels.signature-status.not-signed": "{signed} of {total} have signed",
    "attachments.labels.signature-status.pending": "Awaiting signature",
    "attachments.labels.signature-status.signed": "Signed",
    "attachments.labels.signature-status.unsignable": "Unsignable",
    "attachments.section.title": "Documents",
    "attachments.section.title-with-signatures": "Documents and e-signature",
    "attachments.signatures.modal.button.add-recipient": "Add recipient",
    "attachments.signatures.modal.copy-link": "Copy signing link",
    "attachments.signatures.modal.descriptions.unsignable-attachment": "The uploaded document cannot be signed and must be re-uploaded. Verify that the document is not password protected or corrupted.",
    "attachments.signatures.modal.heading": "Recipients",
    "attachments.signatures.modal.labels.automatic-email": "Automatic e-mail",
    "attachments.signatures.modal.labels.create-links": "Create links",
    "attachments.signatures.modal.labels.deleted-signed-document": "Signed document deleted by {name}, {date}",
    "attachments.signatures.modal.labels.email-sent": "{count, plural, =1 {Email} other {Emails}} sent",
    "attachments.signatures.modal.labels.missing-url": "Link not yet created",
    "attachments.signatures.modal.labels.national-id": "Verify social security number",
    "attachments.signatures.modal.labels.national-id.placeholder": "The recipient's social security number ({maxDigits} digits)",
    "attachments.signatures.modal.labels.saved-changes": "Changes saved",
    "attachments.signatures.modal.labels.send-emails-and-create-links": "Send emails and create links",
    "attachments.signatures.modal.labels.unsaved-changes": "Changes not saved",
    "attachments.signatures.modal.labels.unsignable-attachment": "Attachment is unsignable",
    "attachments.signatures.modal.name.placeholder": "Recipient name",
    "attachments.signatures.modal.table.column.date-signed": "DATE SIGNED",
    "attachments.signatures.modal.title": "Signature for «{filename}»",
    "attachments.table.header.assignment": "ASSIGNMENT",
    "attachments.table.header.created.by": "UPLOADED BY",
    "attachments.table.header.created.date": "UPLOADED",
    "attachments.table.header.document": "DOCUMENT",
    "attachments.table.header.signature-status": "SIGNATURES STATUS",
    "attachments.table.messages.uploading": "Uploading {count, plural, =1 {} other {# attachments}} ...",
    "attachments.upload.button": "Upload document",
    "attachments.upload.button.available-file-types": "Allowed filetypes:",
    "auto-reminders-settings.description": "KDK can automatically notify your recipients of the KYC form in the event of a lack of response. The reminder is sent by e-mail, and only applies to recipients who have been sent a KYC form by e-mail.",
    "auto-reminders-settings.form.label": "When should the reminder be sent?",
    "auto-reminders-settings.limit-options.label": "How many times should we send automatic reminders by e-mail?",
    "auto-reminders-settings.page.title": "Auto Reminders",
    "auto-reminders-settings.send-options.bi-weekly": "Bi-weekly",
    "auto-reminders-settings.send-options.custom": "Custom",
    "auto-reminders-settings.send-options.custom.placeholder": "Number of days",
    "auto-reminders-settings.send-options.not-set": "Do not send automatic reminders",
    "auto-reminders-settings.send-options.weekly": "Weekly",
    "badge.archived": "Archived",
    "badge.negative-news": "Adverse media",
    "badge.other": "Other",
    "badge.pep": "PEP",
    "badge.sanctioned": "Sanction",
    "bulk.actions.add-to-existing-project.label": "Add to existing project",
    "bulk.actions.add-to-new-project.label": "Add to new project",
    "bulk.actions.archive.confirmation.description": "Are you sure you want to archive {names}?",
    "bulk.actions.archive.confirmation.title": "Archive customers",
    "bulk.actions.archive.success.message": "Archived {count, plural, =1 {customer} other {# customers}}",
    "bulk.actions.change-screening-type.label": "Screening settings",
    "bulk.actions.delete.confirmation.check": "I confirm I wish to delete the selected customers",
    "bulk.actions.delete.confirmation.description": "You are about to delete the selected customers permanently from Kjenn Din Kunde.\nThis can not be undone.\nAre you sure you want to delete: {names}?",
    "bulk.actions.delete.confirmation.title": "Delete customers",
    "bulk.actions.delete.success.message": "Deleted {count, plural, =1 {customer} other {# customers}}",
    "bulk.actions.followup.label": "Set follow-up date",
    "bulk.actions.followup.success.message": "Follow-up date changed",
    "bulk.actions.reject-match-cases.confirmation.description": "Are you sure you want to reject {count, plural, =1 {1 match case} other {# match cases}}?",
    "bulk.actions.reject-match-cases.confirmation.title": "Reject match cases",
    "bulk.actions.reject-match-cases.success.message": "Rejected {count, plural, =1 {match case} other {# match cases}}",
    "bulk.actions.responsible.label": "Change responsible users",
    "bulk.actions.responsible.success.message": "Responsible users changed",
    "bulk.actions.restore.confirmation.description": "Are you sure you want to restore {names}?",
    "bulk.actions.restore.confirmation.title": "Restore customers",
    "bulk.actions.restore.success.message": "Restored {count, plural, =1 {customer} other {# customers}}",
    "bulk.actions.screening-type.success.message": "Screening settings was changed",
    "button.go.back": "Back",
    "button.go.next": "Next",
    "change-screening.buttons.save": "Modify screening",
    "change-screening.buttons.start-screening": "Start new screening",
    "change-screening.buttons.stop-monitoring": "Stop screening",
    "change-screening.stop-screening.description": "You will no longer receive updates on any new matches against PEP, sanctions and adverse media on people who have been screened.",
    "change-screening.stop-screening.description-person": "You will no longer receive updates on any new matches against PEP, sanctions and adverse media on the person.",
    "change-screening.stop-screening.title": "Are you sure you want to stop screening?",
    "change-screening.titles.choose-screening-type": "Select type of screening",
    "change-screening.titles.new-screening": "New screening",
    "change-screening.titles.screening-owners": "Screening of owners",
    "change-screening.titles.screening-person": "Screening of",
    "change-screening.titles.screening-roles": "Screening of role holders",
    "change-screening.titles.screening-title": "Change screening",
    "checklists.preview.modal.title": "Preview checklist \"{name}\"",
    "common.address.addressline1": "Address line 1",
    "common.address.addressline2": "Address line 2",
    "common.address.city": "City",
    "common.address.country": "Address country",
    "common.address.county": "County",
    "common.address.postal.code": "Postal code",
    "common.answered.label": "Answered by {name}, {timestamp, date, ::yyyyMMdd}",
    "common.badge.new-info": "NEW INFO",
    "common.banner.followup-expired.description": "The follow-up for this customer is set to {followup, date, ::yyyyMMdd}. Make the necessary follow-up routines, and leave a new assessment of the customer.",
    "common.banner.followup-expired.title": "Ongoing follow-up is due",
    "common.banner.possible.match.description": "Possible match as PEP, sanction or adverse media.",
    "common.banner.possible.match.title": "Possible match",
    "common.buttons.action.edit": "Change info",
    "common.buttons.actions.archive-assignment": "Archive assignment",
    "common.buttons.actions.archive-customer": "Archive customer",
    "common.buttons.actions.button": "Actions",
    "common.buttons.actions.change-screening": "Change screening",
    "common.buttons.actions.create-assignment": "Create assignment",
    "common.buttons.actions.delete-customer": "Delete customer",
    "common.buttons.actions.download.report": "Download report",
    "common.buttons.actions.edit-assignment": "Edit assignment details",
    "common.buttons.actions.edit-company-info": "Edit company details",
    "common.buttons.actions.edit-person-info": "Edit person details",
    "common.buttons.actions.new-assignment": "New assignment",
    "common.buttons.actions.new-assignment-disclosure": "Add KYC questions to assignment",
    "common.buttons.actions.new-disclosure": "Send KYC questions",
    "common.buttons.actions.new-screening": "New screening",
    "common.buttons.actions.restore-assignment": "Restore assignment",
    "common.buttons.actions.restore-customer": "Restore customer",
    "common.buttons.actions.skip-step": "Skip this step",
    "common.buttons.move-down": "Move down",
    "common.buttons.move-up": "Move up",
    "common.country-select.choose-country-option": "Choose country",
    "common.date-input.placeholder": "dd/mm/yyyy",
    "common.errors.company-external-id.exists": "A customer with the same external ID already exists",
    "common.errors.company-national-id.exists": "A customer with the same org.no. already exists",
    "common.errors.company.exists": "A similar company customer already exists",
    "common.errors.email.not-unique": "Email already exists",
    "common.errors.file-size-exceeded": "Uploaded files cannot be larger than {max, number}mb. \nReduce the file size and try again.",
    "common.errors.generic": "An error happened",
    "common.errors.generic.failed-action": "Failed to {actionLabel} ({message})",
    "common.errors.invalid.account-number": "Error in account number. Check that you have included all 11 digits.",
    "common.errors.invalid.address": "Invalid address",
    "common.errors.invalid.birth.date": "Invalid birthdate",
    "common.errors.invalid.citizenship": "Invalid citizenship",
    "common.errors.invalid.comment": "Invalid comment",
    "common.errors.invalid.company.national-id": "Invalid org.no.",
    "common.errors.invalid.email": "Invalid email",
    "common.errors.invalid.empty.mobile-phone": "Empty phone number",
    "common.errors.invalid.empty.name": "Empty name",
    "common.errors.invalid.empty.title": "Empty title",
    "common.errors.invalid.first.name": "Invalid firstname",
    "common.errors.invalid.last.name": "Invalid lastname",
    "common.errors.invalid.missing.last.name": "Last name is missing",
    "common.errors.invalid.name.exists": "Name already exists",
    "common.errors.invalid.national-id.exists": "National ID already exists",
    "common.errors.invalid.person.national-id": "Invalid personal number",
    "common.errors.invalid.person.national-id-country": "Choose a country from the list",
    "common.errors.person-external-id.exists": "A customer with the same external ID already exists",
    "common.errors.person-national-id.exists": "A customer with the same personal number already exists",
    "common.errors.person.exists": "A similar person customer already exists",
    "common.errors.required.first.name": "First name required",
    "common.errors.required.last.name": "Last name required",
    "common.group.role.key.compliance-officer": "Compliance Officer",
    "common.group.role.key.kdk-admin": "KDK Admin",
    "common.group.role.key.mlro": "MLRO",
    "common.labels.address": "Address",
    "common.labels.approve": "Approve",
    "common.labels.approved": "Approved",
    "common.labels.archived-by": "Archived by {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.bank-id": "BankID",
    "common.labels.birth_date": "Date of birth",
    "common.labels.both-customer-types": "Both types of customers",
    "common.labels.business-address": "Business address",
    "common.labels.calculated-ubo": "The ownership share indicates that the person is to be considered the ultimate beneficial owner",
    "common.labels.change-seen": "Change seen",
    "common.labels.citizenship": "Citizenship",
    "common.labels.collapse-all": "Collapse all",
    "common.labels.comment": "Comment",
    "common.labels.complete": "Complete",
    "common.labels.completed-by": "Completed by {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.confirmed-by": "Confirmed by {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.country": "Country",
    "common.labels.country-of-origin": "Country of origin",
    "common.labels.country-of-residence": "Country of residence",
    "common.labels.create-tag": "Create Tag",
    "common.labels.created-by": "Created by {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.customer-relationship": "Customer relationship",
    "common.labels.customer-type": "Choose the type of customers the custom questions should be displayed for:",
    "common.labels.customer-type.company": "Company",
    "common.labels.customer-type.person": "Person",
    "common.labels.customer.risk": "customer risk",
    "common.labels.description": "Description",
    "common.labels.editorial-explanation": "Editorial explanation",
    "common.labels.email": "Email",
    "common.labels.end-date": "End date",
    "common.labels.expand-all": "Expand all",
    "common.labels.file.upload": "Upload file",
    "common.labels.first_name": "First name",
    "common.labels.go-to-support-page": "Go to the support page",
    "common.labels.groups": "Groups",
    "common.labels.include-assignment": "Include assignment",
    "common.labels.kyc": "KYC",
    "common.labels.kyc-responses": "KYC responses",
    "common.labels.last_name": "Last name",
    "common.labels.manual-ubo": "Manually marked as UBO",
    "common.labels.mark-person-as-pep": "Person is PEP",
    "common.labels.mark-person-as-sanctioned": "Person is sanctioned",
    "common.labels.missing-information": "Missing information",
    "common.labels.mobile-phone": "Mobile number",
    "common.labels.modified-by": "Last modified by {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.more-information-at": "More information at",
    "common.labels.name": "Name",
    "common.labels.national-id": "National ID",
    "common.labels.national-id-country": "National ID country",
    "common.labels.nationality": "Nationality",
    "common.labels.office-address": "Office address",
    "common.labels.pep-position-country": "Country of employment for PEP",
    "common.labels.photo": "Photo",
    "common.labels.reject": "Reject",
    "common.labels.rejected": "Rejected",
    "common.labels.rejected-by": "Rejected by {name}, {timestamp, date, ::yyyyMMdd}",
    "common.labels.risk-category.geographical": "Geographical risk",
    "common.labels.risk-category.industry": "Industry risk",
    "common.labels.risk-category.pep": "PEP",
    "common.labels.risk-category.sanction": "Sanction",
    "common.labels.risk-response": "Risk response",
    "common.labels.risk-type": "Risk type",
    "common.labels.save-changes": "Save changes",
    "common.labels.save-settings": "Save settings",
    "common.labels.saved-successfully": "Changes saved",
    "common.labels.selected-customers-count": "Selected customers: {count, number}",
    "common.labels.show-less": "Show less",
    "common.labels.show-more": "Show more",
    "common.labels.show-more-with-count": "Show {count, number} more",
    "common.labels.start-date": "Start date",
    "common.labels.take-me-back": "Take me back",
    "common.labels.title": "Title",
    "common.labels.triggered-when": "Triggered when:",
    "common.labels.try-again": "Try again",
    "common.labels.ubo": "UBO",
    "common.labels.unidentified-owner": "Unidentified owner",
    "common.language.english": "English",
    "common.language.norwegian": "Norwegian",
    "common.loading.data": "Retrieving data",
    "common.month": "{months, plural, =1 {1 month} other {# months}}",
    "common.multiple-names.full": "{fullnames} and {count, number} others",
    "common.multiple-names.short": "{fullnames} and {lastname}",
    "common.reviewed.label": "Reviewed by {name}, {timestamp, date, ::yyyyMMdd}",
    "common.roles.ACCOUNTANT": "Accountant",
    "common.roles.ALTERNATE_BOARD_MEMBER": "Alternate board member",
    "common.roles.AUDITOR": "Auditor",
    "common.roles.BOARD_MEMBER": "Board member",
    "common.roles.CEO": "CEO",
    "common.roles.CHAIRMAN": "Chairman",
    "common.roles.COMPLEMENTARY": "Complementary",
    "common.roles.CONTACT_PERSON": "Contact person",
    "common.roles.DEPUTY_BOARD_MEMBER": "Deputy board member",
    "common.roles.DEPUTY_CHAIRMAN": "Deputy chairman",
    "common.roles.MANAGER": "Manager",
    "common.roles.MANAGING_DIRECTOR": "Managing director",
    "common.roles.NORWEGIAN_REPRESENTATIVE": "Norwegian representative (NUF)",
    "common.roles.OBSERVER": "Observer",
    "common.roles.PARTICIPANT_FULL_RESPONSIBILITY": "Participant with full responsibility",
    "common.roles.PARTICIPANT_PART_RESPONSIBILITY": "Participant with shared responsibility",
    "common.roles.PROCURA": "Procura",
    "common.roles.PROCURA_JOINTLY": "Procura jointly",
    "common.roles.PROCURA_SEPARATELY": "Procura separately",
    "common.roles.PROPRIETOR": "Proprietor",
    "common.roles.REPRESENTATIVE": "Representative",
    "common.roles.SIGNATURE": "Signature",
    "common.roles.SIGNATURE_JOINTLY": "Signature jointly",
    "common.roles.SIGNATURE_SEPARATELY": "Signature separately",
    "common.roles.TRUSTEE": "Trustee",
    "common.roles.UNKNOWN_ROLE": "Unknown role",
    "common.roles.not.in.use": "not in use",
    "common.roles.null": "Unknown role",
    "common.share-class.CLASS_A": "CLASS A SHARES",
    "common.share-class.CLASS_B": "CLASS B SHARES",
    "common.share-class.CLASS_C": "CLASS C SHARES",
    "common.share-class.CLASS_D": "CLASS D SHARES",
    "common.share-class.CLASS_E": "CLASS E SHARES",
    "common.share-class.CLASS_F": "CLASS F SHARES",
    "common.share-class.CLASS_G": "CLASS G SHARES",
    "common.share-class.CLASS_H": "CLASS H SHARES",
    "common.share-class.CLASS_I": "CLASS I SHARES",
    "common.share-class.CLASS_J": "CLASS J SHARES",
    "common.share-class.EXTRAORDINARY_SHARES": "EXTRAORDINARY SHARES",
    "common.share-class.ISIN": "ISIN",
    "common.share-class.ORDINARY_SHARES": "ORDINARY SHARES",
    "common.share-class.PREFERRED_SHARES": "PREFERRED SHARES",
    "common.share-class.UNKNOWN_SHARE_CLASS": "UNKNOWN SHARES",
    "common.vitec.synced": "Synced to Vitec",
    "common.vitec.synchronize": "Synchronize to Vitec",
    "common.year": "{years, plural, =1 {1 year} other {# years}}",
    "company-card.errors.fetch-failed-action": "Fetch company information",
    "company-form.headings.details": "Company details",
    "company-form.labels.country": "Country",
    "company-form.labels.external-id": "External ID",
    "company-form.labels.name": "Company name",
    "company-form.labels.national-id": "Org.no.",
    "company.details.caption.address": "ADDRESS",
    "company.details.caption.address.postal": "POSTAL ADDRESS",
    "company.details.caption.address.visit": "VISITING ADDRESS",
    "company.details.caption.closure_date": "Closure Date",
    "company.details.caption.company.type": "ORG. FORM",
    "company.details.caption.country": "COUNTRY",
    "company.details.caption.employees": "EMPLOYEES",
    "company.details.caption.est": "ESTABLISHED",
    "company.details.caption.external-id": "ID",
    "company.details.caption.industry-codes": "INDUSTRY CODES",
    "company.details.caption.is_bankrupt": "Bankrupt",
    "company.details.caption.name": "NAME",
    "company.details.caption.national_id": "ORG.NO.",
    "company.details.caption.registered-in-foundation": "REGISTERED IN FOUNDATION REGISTRY",
    "company.details.caption.registered-in-vat": "REGISTERED IN VAT REGISTRY",
    "company.details.caption.under_forced_liquidation": "UNDER FORCED LIQUIDATION",
    "company.details.caption.under_liquidation": "UNDER LIQUIDATION",
    "company.details.caption.website": "HOMEPAGE",
    "company.details.changes.tooltip.banner": "Changes in company details are shown as \"New\" until it is marked as \"Change seen\" or a new customer review has been made",
    "company.details.changes.tooltip.button.label": "New customer review",
    "company.details.new-role.tooltip.banner": "New roles are marked as «New» until a new screening has been performed",
    "company.details.new-role.tooltip.button.label": "Change screening",
    "company.details.onboarding.no-screening-performed": "No screening performed",
    "company.details.onboarding.title": "Covered by screening",
    "company.details.screening.title": "who is covered by screening",
    "company.details.title": "company details",
    "company.owners.archive.description": "Are you sure you want to archive: <bold>{name}</bold>?",
    "company.owners.hide-historical-owners": "Hide historical owners",
    "company.owners.title": "Ownership overview",
    "company.owners.view-historical-owners": "View historical owners",
    "company.owners.warning.foreign-company": "The shareholder register provides information that a company has shares in your customer, but the information is incomplete. Contact the customer to get an overview of the ownership and control structure and real rights holders.",
    "company.owners.warning.unidentified-owner": "Your customer has owner(s) in the ownership structure that cannot be identified from the Shareholder Register. Contact the customer to get an overview of the ownership and control structure and real rights holders.",
    "company.roles.title": "Role Holders",
    "component.filter.country.title": "Country",
    "component.filter.customer.option.company.title": "Company",
    "component.filter.customer.option.person.title": "Person",
    "component.filter.customer.title": "Customer type",
    "component.filter.risk.title": "Risk",
    "component.filter.screening.title": "Screening type",
    "component.filters.all.title": "All",
    "component.filters.archive.option.include-archived-customers": "Show archived customers",
    "component.filters.archive.title": "Archived customers",
    "component.filters.button.reset": "Reset",
    "component.filters.created-after.title": "Added after",
    "component.filters.created-before.title": "Added before",
    "component.filters.created.applied.range.MONTH": "Added in the last month",
    "component.filters.created.applied.range.WEEK": "Added in the last week",
    "component.filters.created.applied.range.YEAR": "Added in the last year",
    "component.filters.created.labels.after": "Added after {date}",
    "component.filters.created.labels.before": "Added before {date}",
    "component.filters.created.range.ALL": "All",
    "component.filters.created.range.CUSTOM": "Custom range",
    "component.filters.created.range.MONTH": "Last month",
    "component.filters.created.range.WEEK": "Last week",
    "component.filters.created.range.YEAR": "Last year",
    "component.filters.created.title": "Added",
    "component.filters.followup-after.title": "Follow-up after",
    "component.filters.followup-before.title": "Follow-up before",
    "component.filters.followup-expired.title": "Follow-up expired",
    "component.filters.followup.applied.range.MONTH": "Follow-up in the next month",
    "component.filters.followup.applied.range.WEEK": "Follow-up in the next week",
    "component.filters.followup.applied.range.YEAR": "Follow-up in 12 months",
    "component.filters.followup.labels.after": "Follow-up after {date}",
    "component.filters.followup.labels.before": "Follow-up before {date}",
    "component.filters.followup.option.expired": "Follow-up expired",
    "component.filters.followup.range.ALL": "All",
    "component.filters.followup.range.CUSTOM": "Custom range",
    "component.filters.followup.range.MONTH": "Next month",
    "component.filters.followup.range.WEEK": "Next week",
    "component.filters.followup.range.YEAR": "Next year",
    "component.filters.followup.title": "Follow-up",
    "component.filters.include.archive.title": "Include archived customers",
    "component.filters.industry-type.title": "Industry Type",
    "component.filters.marked-as.option.pep": "PEP",
    "component.filters.marked-as.option.sanction": "Sanctioned",
    "component.filters.marked-as.title": "Marked as (PEP/Sanctioned)",
    "component.filters.match.option.open.matches": "Open matches",
    "component.filters.match.text.open.matches": "Has unreviewed matches",
    "component.filters.match.text.pep.matches": "Marked as PEP",
    "component.filters.match.text.sanction.matches": "Marked as sanctioned",
    "component.filters.ownership-updates.label": "Only show customers with updated shareholder data",
    "component.filters.ownership-updates.title": "Ownership updates",
    "component.filters.pending-measures.option": "Has pending measures",
    "component.filters.pending-measures.title": "Has pending measures",
    "component.filters.project.option.active": "Active",
    "component.filters.project.option.inactive": "Inactive",
    "component.filters.responsible.user.inactive": "Inactive",
    "component.filters.saved-filters.delete-filter": "Delete saved filter",
    "component.filters.saved-filters.deleted.message": "Saved filter deleted",
    "component.filters.saved-filters.empty.message": "Add filters to the customer list and click “Save filters” to save",
    "component.filters.saved-filters.filter-name": "Filter name",
    "component.filters.saved-filters.my-customers": "My customers",
    "component.filters.saved-filters.save-filters.label": "Save filters",
    "component.filters.saved-filters.saved.message": "Filters saved 🎉",
    "component.filters.saved-filters.title": "Saved filters",
    "component.filters.saved-filters.without-filters": "Without filters",
    "component.filters.screening.option.monitoring": "Continuous",
    "component.filters.screening.option.one-time": "One time",
    "component.filters.status.approved": "Approved",
    "component.filters.status.draft-review": "Draft Review",
    "component.filters.status.not-ready": "Not ready",
    "component.filters.status.rejected": "Rejected",
    "component.filters.status.review-approval-required": "Pending review approval",
    "component.filters.status.review-required": "Review Required",
    "component.filters.status.started": "Started",
    "component.filters.status.title": "Status",
    "component.filters.tags.title": "Tags",
    "component.filters.text.and": "and",
    "component.filters.unresolved-matched.title": "Matches",
    "component.notes.delete.confirmation.description": "Are you sure you want to delete the note?",
    "component.notes.delete.confirmation.title": "Delete note",
    "component.notes.labels.save-note": "Save note",
    "component.notes.title": "Notes {count, plural, =0 {} other {(#)}}",
    "component.pagination.labels.select-limit": "Show {limit} customers",
    "component.pagination.labels.showing": "Showing {start, number} - {end, number} of {count, number}",
    "component.questionnaires-list.empty": "You haven’t created any custom KYC-questions yet. It can be created [here]({link}).  \nPS. It is the Money Laundering Officer / Compliance Officer in your company who creates this in Settings.",
    "component.questionnaires-list.filter.label": "Filter questionnaires:",
    "component.questionnaires-list.loading": "Loading questionnaires",
    "component.questionnaires-list.loading.error-action": "Get questionnaires list",
    "component.review.checklist.added.toast.message": "New checklist added.",
    "component.review.checklist.added.toast.scroll.label": "View checklist",
    "component.review.checklist.create-instance": "Use template",
    "component.review.checklist.form.remove.confirmation.description": "Are you sure you want to remove the checklist «{name}»?",
    "component.review.checklist.form.remove.confirmation.title": "Remove checklist",
    "component.review.checklist.select.button.label.add": "Add checklist",
    "component.review.checklist.select.checklists-list.filter.label": "Filter checklists:",
    "component.review.checklist.select.checklists-list.loading": "Loading checklists",
    "component.review.checklist.select.checklists-list.loading.error": "Something went wrong when retrieving the checklists",
    "component.review.checklist.template.title": "Choose template",
    "component.search.customers.hint": "Search customers",
    "component.users-list.all-users.title": "All Users",
    "component.users-list.filter.label": "Filter users:",
    "component.users-list.loading": "Loading users",
    "component.users-list.loading.error-action": "Get users list",
    "copy-label.buttons.copy.tooltip": "Copy to clipboard",
    "customer-assignments.completed": "Completed",
    "customer-assignments.details.assignment-description": "Assignment description",
    "customer-assignments.details.assignment-industry-type": "Assignment industry",
    "customer-assignments.details.assignment-purpose": "Assignment purpose",
    "customer-assignments.details.assignment-risk": "Assignment risk",
    "customer-assignments.empty": "This customer has no assignments yet.",
    "customer-assignments.list.filter.hide-archived-assignments": "Hide archived assignments ({count, number})",
    "customer-assignments.list.filter.show-archived-assignments": "Show archived assignments ({count, number})",
    "customer-assignments.list.header.added": "ADDED",
    "customer-assignments.list.header.name": "NAME",
    "customer-assignments.list.header.responsible": "RESPONSIBLE USERS",
    "customer-assignments.list.header.risk": "RISK",
    "customer-assignments.list.header.status": "STATUS",
    "customer-assignments.modal.assignment-description": "Assignment description",
    "customer-assignments.modal.assignment-industry": "Assignment industry type (optional)",
    "customer-assignments.modal.assignment-industry.placeholder": "Choose an industry from the list",
    "customer-assignments.modal.assignment-name": "Assignment name",
    "customer-assignments.modal.assignment-purpose": "Assignment purpose (optional)",
    "customer-assignments.modal.assignment-purpose.placeholder": "Choose from list or define a new purpose",
    "customer-assignments.modal.assignment-purpose.placeholder-without-description": "Choose a purpose from the list",
    "customer-assignments.no-disclosures.text": "There are no KYC requests sent in this assignment.",
    "customer-assignments.no-disclosures.title": "Add KYC requests to this assignment by clicking the button below. Add KYC to Assignment.",
    "customer-assignments.review.button.action": "Review assignment",
    "customer-assignments.review.button.change": "Change review",
    "customer-assignments.review.not-reviewed": "The assignment has not been reviewed yet",
    "customer-assignments.review.status.pending": "Pending review",
    "customer-assignments.review.status.waiting": "Awaiting identification",
    "customer-assignments.review.title": "Assignment review",
    "customer-assignments.title": "Customer assignments",
    "customer-notifications-settings.description": "Select how often you want to receive updates on company information from the Register of Legal Entities. Select <bold>immediate</bold> if you want email for each company update, select <bold>daily</bold> if you want email that collects daily updates, select <bold>weekly</bold> if you want email that collects weekly updates.",
    "customer-notifications-settings.frequency.label": "How often would you like to receive email notifications?",
    "customer-notifications-settings.frequency.options.daily": "Daily",
    "customer-notifications-settings.frequency.options.immediately": "Immediately",
    "customer-notifications-settings.frequency.options.weekly": "Weekly",
    "customer-notifications-settings.page.title": "Company information updates",
    "customer-projects.empty": "No projects were found.",
    "customer-review-assignment.labels.include-assignment": "Select what the risk assessment applies to",
    "customer-review-guideline-settings.labels.guideline.header": "Guideline header",
    "customer-review-guideline-settings.page.description": "Customize the customer review guidelines",
    "customer-review-guideline-settings.page.reset.confirmation.description": "Are you sure you want to reset the customer review guidelines back to default?\nThis will erase all the changes that were made to both Person and Company guidelines.",
    "customer-review-guideline-settings.page.reset.confirmation.title": "Reset customer review guidelines",
    "customer-review-guideline-settings.page.title": "Customer review guidelines",
    "customer.checklist.review.form.header": "Checklists",
    "customer.details.archived-date": "Archived by {name}, {timestamp, date, ::yyyyMMdd}",
    "customer.notes.placeholder": "Leave a note about the customer",
    "customers.list.column.added": "ADDED",
    "customers.list.column.customer": "CUSTOMER",
    "customers.list.column.customers.count": "CUSTOMERS COUNT",
    "customers.list.column.external-id": "ID",
    "customers.list.column.report": "REPORT",
    "customers.list.column.responsible.users": "RESPONSIBLE USERS",
    "customers.list.column.risk": "RISK",
    "customers.list.column.tasks": "TASKS",
    "customers.list.empty.content": "There were no customers matching your search and/or filter selections",
    "customers.list.empty.title": "Your search returned no results",
    "customers.list.external-id.tooltip": "External ID: {id}",
    "customers.list.fresh-customer.content": "Then it's probably time to get started!",
    "customers.list.fresh-customer.label": "Now I am ready!",
    "customers.list.fresh-customer.title": "You haven't added any customers yet?",
    "customers.list.header.customers.count": "Number of customers: {count, number} {selected, plural, =0 {} other {(# selected)}}",
    "customers.list.header.customers.count.all": "Number of customers: {count, number} (all selected)",
    "customers.list.header.selected.count": "{count} selected",
    "customers.list.paging.limit.select.label": "Show {limit} items",
    "customers.list.paging.next": "Next",
    "customers.list.paging.previous": "Previous",
    "customers.list.paging.showing": "Showing {start} - {end} of {count}",
    "customers.list.tabs.labels.all": "All customers ({count, number})",
    "customers.list.tabs.labels.pending-tasks": "Customers with pending tasks",
    "customers.list.title": "Customers",
    "dashboard.filters.date.from": "From: {date}",
    "dashboard.filters.date.interval.ANNUALLY": "Last year",
    "dashboard.filters.date.interval.CUSTOM_DATE_RANGE": "Custom range",
    "dashboard.filters.date.interval.DAILY": "Last day",
    "dashboard.filters.date.interval.MONTHLY": "Last month",
    "dashboard.filters.date.interval.QUARTERLY": "Last quarter",
    "dashboard.filters.date.interval.WEEKLY": "Last week",
    "dashboard.filters.date.title": "Date range",
    "dashboard.filters.date.until": "Until: {date}",
    "dashboard.widgets.active-customers.title": "My Customers",
    "dashboard.widgets.industry-types.empty.message": "No industries found",
    "dashboard.widgets.industry-types.filter.placeholder": "Filter industries",
    "dashboard.widgets.industry-types.title": "Industry Types",
    "dashboard.widgets.marked-as-pep.title": "Customers marked as PEP",
    "dashboard.widgets.marked-as-sanctioned.title": "Sanctioned Customers",
    "dashboard.widgets.pending-tasks.title": "Customers with pending tasks",
    "dashboard.widgets.risk-data.PEP": "Politically Exposed Person",
    "dashboard.widgets.risk-data.by.assignment.title": "AML reporting for real estate brokerage businesses - by assignment",
    "dashboard.widgets.risk-data.by.assignment.tooltip": "The figures are linked to assignments imported from Vitec Next and include archived assignments.\n\nThe figures are taken from the KYC response(s), with the exception of PEP status and connection to high-risk countries. PEP status depends on whether the customer is marked as PEP in Know Your Customer. High risk country affiliation is a combination of information registered in Know Your Customer and KYC response.",
    "dashboard.widgets.risk-data.by.customer.title": "AML reporting for real estate brokerage businesses - by customer",
    "dashboard.widgets.risk-data.by.customer.tooltip": "The figures include all customers who have answered at least one KYC form, and include archived customers.\n\nThe figures are taken from the KYC response(s), with the exception of PEP status and connection to high-risk countries. PEP status depends on whether the customer is marked as PEP in Know Your Customer. High risk country affiliation is a combination of information registered in Know Your Customer and KYC response.",
    "dashboard.widgets.risk-data.construction-industry": "Industry affiliation in the construction industry",
    "dashboard.widgets.risk-data.financed-crowdfunding": "Funded by crowdfunding",
    "dashboard.widgets.risk-data.financed-crypto": "Funded by cryptocurrency or crypto art",
    "dashboard.widgets.risk-data.high-risk-country": "Connection to high-risk countries",
    "dashboard.widgets.risk-data.high-risk-industry": "Industry affiliation to other high risk industries",
    "dashboard.widgets.risk-data.missing-funding-documentation": "Renovated with unknown origin of financing",
    "dashboard.widgets.risk-data.missing-work-documentation": "Renovated whole/parts without invoice",
    "dashboard.widgets.risk-levels.title": "Risk level - all customers",
    "dashboard.widgets.status.title": "Approve and Rejected",
    "default.add": "Add",
    "default.archive": "Archive",
    "default.cancel": "Cancel",
    "default.categories": "categories",
    "default.change": "Change",
    "default.close": "Close",
    "default.confirm": "Confirm",
    "default.copy": "Copy",
    "default.create": "Create",
    "default.days": "{days, plural, =1 {day} other {days}}",
    "default.delete": "Delete",
    "default.down-from": "Down from {value}",
    "default.edit": "Edit",
    "default.email": "E-mail",
    "default.expired": "Expired",
    "default.hide": "Hide",
    "default.history": "history",
    "default.home": "Home",
    "default.inactive": "Inactive",
    "default.industries": "industries",
    "default.invalid": "Invalid",
    "default.keep": "Keep",
    "default.link": "Link",
    "default.loading": "Loading",
    "default.mandatory": "Mandatory",
    "default.months": "{months, plural, =1 {month} other {months}}",
    "default.new": "New",
    "default.next": "Next",
    "default.no": "No",
    "default.normal": "Normal",
    "default.or": "or",
    "default.preview": "Preview",
    "default.previous": "Previous",
    "default.reject": "Reject",
    "default.remove": "Remove",
    "default.required": "Required",
    "default.reset": "Reset",
    "default.restore": "Restore",
    "default.risk": "Risk",
    "default.save": "Save",
    "default.save-changes": "Save changes",
    "default.search": "Search",
    "default.send": "Send",
    "default.show": "Show",
    "default.status": "Status",
    "default.support-portal": "support portal",
    "default.times": "{count, plural, =1 {time} other {# times}}",
    "default.unknown": "Unknown",
    "default.up-from": "Up from {value}",
    "default.view": "View",
    "default.years": "{years, plural, =1 {year} other {years}}",
    "default.yes": "Yes",
    "delete-customer.confirmation-modal.description": "You are about to delete {name} permanently from Kjenn Din Kunde.\nThis can not be undone.\nAre you sure you want to delete this customer?",
    "delete-customer.confirmation-modal.labels.button.delete": "Delete {name}",
    "delete-customer.confirmation-modal.success.message": "{name} was deleted",
    "delete-customer.confirmation-modal.title": "Delete customer",
    "details.banners.critical-update.content": "There have been changes in this customer, which have consequences for the customer relationship.",
    "details.banners.critical-update.title": "Company changes that have consequences",
    "details.banners.ownership-updates.content": "We have received updated information from the Shareholder Register, and therefore have new information on licensees belonging to this customer.",
    "details.banners.ownership-updates.link-label": "See updates",
    "details.banners.screening.in.progress.content": "Waiting for results of screening",
    "details.banners.screening.in.progress.title": "Screening in progress",
    "details.basic-info.customer-risk": "Customer risk",
    "details.basic-info.follow-up": "Ongoing follow-up",
    "details.basic-info.marked-as": "Marked as",
    "details.basic-info.screening-type": "Screening type",
    "details.basic-info.status": "Review Status",
    "details.reviews.approved-by": "Approved by: ",
    "details.reviews.assignment-review.accepted": "Assignment accepted",
    "details.reviews.assignment-review.rejected": "Assignment rejected",
    "details.reviews.awaiting-approval": "Awaiting approval",
    "details.reviews.awaiting-approval-with-names": "Awaiting approval by {names}",
    "details.reviews.awaiting-measures": "Waiting to complete measures",
    "details.reviews.confirm.approve": "Approve review",
    "details.reviews.confirm.approve-reject.title": "Rationale",
    "details.reviews.confirm.cancel.description": "Are you sure you want to discard changes?",
    "details.reviews.confirm.cancel.title": "Discard changes",
    "details.reviews.confirm.delete.description": "Are you sure you want to delete the review?\n(This operation can not be undone)",
    "details.reviews.confirm.delete.title": "Delete review",
    "details.reviews.confirm.reject": "Reject review",
    "details.reviews.confirm.reject.description": "By rejecting the assessment, it must be redone by the employee.",
    "details.reviews.confirmed-by": "Confirmed by: ",
    "details.reviews.customer-review.accepted": "Customer relationship accepted",
    "details.reviews.customer-review.rejected": "Customer relationship rejected",
    "details.reviews.draft": "Draft review",
    "details.reviews.labels.cancel": "Yes, discard changes",
    "details.reviews.labels.confirm-delete": "Yes, delete review",
    "details.reviews.labels.delete": "Delete review",
    "details.reviews.labels.save-and-continue": "Save and continue later",
    "details.reviews.measures.comment.label": "Actions taken:",
    "details.reviews.measures.edit-measure": "Take action",
    "details.reviews.measures.form.completed.label": "Has this been resolved?",
    "details.reviews.measures.form.description.label": "Describe actions",
    "details.reviews.measures.form.description.placeholder": "Enter results from measure taken",
    "details.reviews.measures.header": "measures",
    "details.reviews.measures.remove-confirmation.description": "Are you sure you want to remove the measure «{name}»?",
    "details.reviews.measures.remove-confirmation.title": "Remove measure",
    "details.reviews.messages.saved": "Review is saved",
    "details.reviews.pending-measures": "The review is not completed until all the measures have been completed",
    "details.reviews.rejected-by": "Rejected by: ",
    "details.reviews.reviewed-by": "Reviewed by: ",
    "details.reviews.risk-set-from-x-to-y": "Customer risk changed from {beforeRisk} to {risk}",
    "details.reviews.risk-set-to-x": "Customer risk set to {risk}",
    "disclosure-card.completed.subtitle": "Completed at {timestamp, date, ::yyyyMMdd}",
    "disclosure-card.content-language": "CONTENT LANGUAGE",
    "disclosure-card.date-tile": "DATE CREATED",
    "disclosure-card.email-tile": "EMAIL ADDRESS",
    "disclosure-card.expired-banner.description": "No more automatic reminders will be sent. You must now send a reminder manually, or contact the customer directly.",
    "disclosure-card.expired-banner.title": "Missing KYC response",
    "disclosure-card.identification.label": "Identified person ({method})",
    "disclosure-card.link-tile": "LINK",
    "disclosure-card.next-notification.subtitle": "Next reminder: {timestamp, date, ::yyyyMMdd}",
    "disclosure-card.notified.subtitle": "Last notified at {timestamp, date, ::yyyyMMdd}",
    "disclosure-card.pin-tile": "PIN",
    "disclosure-card.recipient-tile": "RECIPIENT",
    "disclosure-card.scope-tile": "INCLUDED",
    "disclosure-card.status-tile": "STATUS",
    "disclosure-collapsible.hide": "Hide answers",
    "disclosure-collapsible.show": "Show answers",
    "disclosure-documents.empty": "No requests sent",
    "disclosure-documents.title": "KYC and identification",
    "disclosure-request.banner.no.signing-basis": "Signing basis does not exist",
    "disclosure-request.banner.signatory-rights": "Signatory rights in {company}",
    "disclosure-request.button.add-representative": "Add representative",
    "disclosure-request.button.send": "Create request",
    "disclosure-request.column.content-language": "Content language",
    "disclosure-request.column.custom-questionnaires": "Add your own KYC-questions",
    "disclosure-request.column.customer": "Customer",
    "disclosure-request.column.email": "E-mail address",
    "disclosure-request.column.sending-method": "Sending method",
    "disclosure-request.field.email.placeholder": "Receivers e-mail address",
    "disclosure-request.field.use_pep_disclosure": "PEP questions",
    "disclosure-request.field.use_standard_disclosure": "KYC questions (inc. PEP questions)",
    "disclosure-request.field.use_verification": "Identification (BankID)",
    "disclosure-request.title": "Send request regarding identification and KYC questions",
    "disclosure-request.toggle.automatic-email": "Send e-mail",
    "disclosure-status.completed": "Completed",
    "disclosure-status.expired": "Expired",
    "disclosure-status.waiting": "Awaiting answer",
    "disclosure-status.warning": "Found {count, plural, =1 {1 high risk answer} other {# high risk answers}}",
    "disclosure.fileset.document-type.ARTICLES_OF_ASSOCIATION": "Articles of Association",
    "disclosure.fileset.document-type.COMPANY_STRUCTURE": "Company Structure",
    "disclosure.fileset.document-type.FAMILY_OWNERSHIP": "Family Ownership",
    "disclosure.fileset.document-type.HOMEOWNER_AGREEMENT": "UBO Agreement",
    "disclosure.fileset.document-type.HOMEOWNER_POWER_OF_ATTORNEY": "Power of Attorney",
    "disclosure.fileset.document-type.POWER_OF_ATTORNEY": "Power of Attorney",
    "disclosure.fileset.document-type.PRIVATE_LOAN_AGREEMENT": "Private loan agreement",
    "disclosure.fileset.document-type.PRIVATE_LOAN_AGREEMENT_DEVELOPED_PROPERTY": "Private loan agreement",
    "disclosure.fileset.document-type.PROPERTY_OWNERSHIP_STRUCTURE": "Property ownership Structure",
    "disclosure.fileset.document-type.SHAREHOLDER_BOOK": "Shareholder Book",
    "disclosure.fileset.document-type.UBO_AGREEMENT": "UBO Agreement",
    "disclosure.fileset.document-type.UPGRADE_FUNDING_DOCUMENTATION": "Upgrade funding documentation",
    "disclosure.fileset.document-type.UPGRADE_WORK_DOCUMENTATION": "Upgrade work documentation",
    "disclosure.foreign-assignment-description": "Countries other than Norway that are involved in the assignment",
    "disclosure.settings.page.description": "Customize the content sent to your customers by email (identification and KYC) to make it more personal. You have the option to upload your own logo and write a custom text which will be visible in the email. (Your logo will also be visible on the forms which are created and sent as a link.)",
    "disclosure.settings.page.labels.email.due-diligence.identification": "Identification with BankID",
    "disclosure.settings.page.labels.email.due-diligence.kyc": "Questions relevant for the customer relationship",
    "disclosure.settings.page.labels.email.due-diligence.list.title": "The due diligence contains:",
    "disclosure.settings.page.labels.email.header": "Hi, (Name of customer).",
    "disclosure.settings.page.labels.email.subject.company": "COMPANY NAME is conducting a due diligence",
    "disclosure.settings.page.labels.email.subject.person": "COMPANY NAME is conducting a due diligence",
    "disclosure.settings.page.labels.logo": "Upload your own logo",
    "disclosure.settings.page.labels.supported-filetypes": "You can upload .jpg or .png (up to {limit} KB)",
    "disclosure.settings.page.labels.text": "Add your own text in the email",
    "disclosure.settings.page.tabs.customer-type.company": "Company customers",
    "disclosure.settings.page.tabs.customer-type.person": "Person customers",
    "disclosure.settings.page.title": "Logo and text",
    "disclosure.source-of-funds": "Source of Funds",
    "disclosure.timestamp": "Answered",
    "disclosure.ubo-agreements-description": "Information regarding agreement(s) and person(s) who have actual control over the company",
    "disclosure.ubo-agreements-exists": "Are there articles of association, shareholder agreement(s) or other agreement that have provisions on who (directly or indirectly) controls the company?",
    "disclosure.ubo-company-control.heading": "Questions regarding ultimate beneficial owners and company control",
    "disclosure.ubo-company-structure-description": "Information regarding the company structure in the company",
    "disclosure.ubo-company-structure-exists": "Is the company you are acting on the behald of, part of a company structure?",
    "disclosure.ubo-family-members-description": "Information regarding family members which collectively exercise actual control over the company",
    "disclosure.ubo-family-members-exists": "Do family members collectively, directly or indirectly, own more than 25% of the voting shares, or collectively exercise actual control over the company?",
    "disclosure.ubo-share-classes-description": "Information regarding share classes in the company",
    "disclosure.ubo-share-classes-exists": "Are there multiple share classes in the company you are acting on the behalf of?",
    "disclosure.ubo-structure-changes-description": "Information regarding changes in the ownership structure",
    "disclosure.ubo-structure-changes-exists": "Have there been changes in the ownership structure?",
    "disclosure.usage-of-funds": "What will the funds from the sale be used for?",
    "display-name.suffixes.labels.birth-date": "(b. {birthDate, date, ::yyyy})",
    "display-name.suffixes.labels.org-id": "(org.no. {orgId})",
    "email.invalid.address.error": "Invalid address",
    "email.placeholder.text": "Email address",
    "email.required.error": "Email required",
    "error.message.unknown": "An error occurred",
    "error.page.description": "Give it a few seconds and try again",
    "error.page.title": "Unfortunately, an error has occurred...",
    "expired.actions.logout": "Log in",
    "expired.description": "For security reasons, you will be logged out after 30 minutes (if you are not active)",
    "expired.heading": "You must log in again",
    "fetch.identification.info.card.note": "This is further described in chapter 4.3 of Finanstilsynets guide to the Money Laundering Act.",
    "fetch.identification.info.card.text": "Companies subject to reporting under the Money Laundering Act are in accordance to §12 in the law regarding measures against money laundering and financing of terror obliged to obtain identification from customers when it is a physical person, as well as for physical persons acting on behalf a company.",
    "fetch.identification.info.card.title": "Why is obtaining identification necessary?",
    "followup-notifications.settings.intervals.description": "Choose how often you want to receive notification of pending/expired follow-ups by email. The email contains a link to Know Your Customer with a filter view of the customers you need to follow up.",
    "followup-notifications.settings.page.title": "Customer follow-up interval",
    "followup-settings.intervals.description": "You can define follow-up intervals for each risk level. When the follow-up date for a customer expires, the customer's status changes to \"awaiting follow-up\". The customer must then be risk assessed again.",
    "followup-settings.intervals.labels.custom-interval": "Custom interval",
    "followup-settings.intervals.labels.custom-interval.placeholder": "Number of months",
    "followup-settings.intervals.labels.no-interval": "No interval",
    "followup-settings.page.link-to-notifications": "PS. Under <link>, you can define how often you want to receive email notifications about pending/expired follow-ups.",
    "followup-settings.page.title": "Customer follow-up",
    "followup.modal.labels.date": "Select a new follow-up date",
    "followup.modal.message": "Set follow-up date for {names}",
    "followup.modal.title": "Set Follow Up Date",
    "followup.select.empty.label": "Select follow up date",
    "followup.select.error-action": "Set follow-up date",
    "followup.select.expired.label": "Expired: {followup, date, ::yyyyMMdd}",
    "followup.select.label": "Next: {followup, date, ::yyyyMMdd}",
    "followup.select.success.message": "Follow-up date successfully changed",
    "followup.select.title": "Custom date on next follow-up",
    "high-risk-countries.list.EU": "EU",
    "high-risk-countries.list.EU_TAX_HAVEN": "EU Tax Haven",
    "high-risk-countries.list.FATF": "FATF",
    "import-customers.wizard.labels.finished": "Finished importing",
    "import-customers.wizard.labels.first-row-contains-headers": "First row contains headers",
    "import-customers.wizard.labels.import-companies.button": "Import companies",
    "import-customers.wizard.labels.import-people.button": "Import people",
    "import-customers.wizard.labels.importing": "Importing {count, number} out of {total, number} rows",
    "import-customers.wizard.page.title.companies": "Import Companies",
    "import-customers.wizard.page.title.people": "Import People",
    "import-customers.wizard.page.welcome.description": "Welcome to the customers import wizard",
    "import-customers.wizard.page.welcome.title": "Welcome to the customers import wizard",
    "import-customers.wizard.status.IMPORTED": "Imported successfully",
    "import-customers.wizard.status.IMPORTING": "Importing...",
    "import-customers.wizard.status.IMPORT_ERROR": "Failed to import",
    "import-customers.wizard.status.INITIAL": "Read from file",
    "import-customers.wizard.status.READY_FOR_IMPORT": "Ready for import",
    "import-customers.wizard.status.VALIDATION_ERROR": "Validation error",
    "import-customers.wizard.table.hide-column-button.tooltip": "Hide column",
    "import-customers.wizard.validation-error.duplicate-org-id": "Duplicate Org. ID found",
    "import-customers.wizard.validation-error.invalid-org-id": "Invalid Org. ID",
    "import-customers.wizard.validation-error.responsible-user-not-found": "Responsible user not found",
    "import-customers.wizard.warning.missing-columns": "{count, plural, one {This column} other {These columns}} must be selected: {names}",
    "import-customers.wizard.warning.multiple-columns": "{count, plural, one {This column} other {These columns}} must be selected only once: {names}",
    "in.progress": "In progress",
    "industry-info.labels.industry-code": "Industry code",
    "industry-info.labels.possible-risk": "Possible risk",
    "industry-types.filter.label": "Filter industry types",
    "kar.form.labels.account-number": "Account number",
    "kar.form.labels.check-account-number": "Check account number",
    "kar.form.labels.customer-number": "Social security number / Org.nr",
    "kar.form.result.by": "Time of search: {timestamp, date, ::yyyyMMdd HH:mm} - performed by {name}",
    "kar.form.result.failure": "The account number <bold>{accountNumber}</bold> does not belong to <bold>{name} ({nationalId})</bold>",
    "kar.form.result.success": "The account number <bold>{accountNumber}</bold> belongs to <bold>{name} ({nationalId})</bold>",
    "kar.form.title": "Verify account information",
    "kar.table.status.failure.tooltip": "No link between account number and social security number / org. no.",
    "kar.title": "KAR-register",
    "links.go-back": "Back to {name}",
    "lookup.again": "Lookup again",
    "lookup.button.search": "Lookup company",
    "lookup.correct.customer": "This is correct customer",
    "lookup.error.company.bankrupt": "The company is bankrupt",
    "lookup.error.company.closed": "The company is closed/deleted",
    "lookup.error.company.not.found": "Could not find a company with this number {orgId}",
    "lookup.error.company.under-forced-liquidation": "The company is under forced liquidation or dissolution",
    "lookup.error.company.under-liquidation": "The company is under liquidation",
    "lookup.error.title": "Cannot register company",
    "lookup.error.wrong.orgid": "Wrong org number",
    "lookup.input.placeholder": "Org.no. (9 digits)",
    "lookup.search.title": "Search for the company using org number",
    "lookup.title": "Confirm customer",
    "match-cases-section.count.label": "Number of match cases: {count, number} {selected, plural, =0 {} other {(# selected)}}",
    "match.basic-info.id": "ID:",
    "match.basic-info.last-updated": "Last updated:",
    "match.basic-info.match-date": "Date on match:",
    "match.relations.ACTING": "ACTING FOR OR ON BEHALF OF",
    "match.relations.CHILD": "CHILD",
    "match.relations.DAUGHTER": "DAUGHTER",
    "match.relations.FATHER": "FATHER",
    "match.relations.MOTHER": "MOTHER",
    "match.relations.PARENT": "PARENT",
    "match.relations.RELATIVE": "RELATIVE",
    "match.relations.SIBLING": "SIBLING",
    "match.relations.SPOUSE": "SPOUSE",
    "match.relations.WIFE": "WIFE",
    "matches.button.confirm.match.description-company": "The match applies to the right company and is relevant",
    "matches.button.confirm.match.description-person": "The match applies to the right person and is relevant",
    "matches.button.decline.match.description-company": "The match does not apply to the right company, or is not relevant",
    "matches.button.decline.match.description-person": "The match does not apply to the right person, or is not relevant",
    "matches.button.hide.rejected.matches": "Hide rejected matches ({count})",
    "matches.button.review-next-match": "Review next match",
    "matches.button.show.rejected.matches": "Show rejected matches ({count})",
    "matches.help-text.pep.description": "Assess whether the information in the match entails that your customer/representative is a PEP, or a closely related family member or known associate of a PEP.\n\n**Which positions and functions are covered by the PEP definition?**\n\nPolitically exposed persons (PEP) are individuals who hold, or have held, the following positions or functions according to the [Anti-Money Laundering Act § 2 letter f](https://lovdata.no/lov/2018-06-01-23/§2).\n\nSpecific _national_ positions are specified below.\n\n\n\n* Head of state, head of government, minister and assistant minister\n    * _The king_\n    * _The prime minister_\n    * _cabinet ministers_\n    * _state secretaries_\n* Member of parliament \n    * _Members of parliament, regular or permanent deputy members_\n* Member of a governing body of a political party\n    * _Main board or equivalent high-ranking body in political parties represented in parliament (municipal and county councils are not included)_\n* Member of a high-level judicial body making decisions that cannot, or only exceptionally, be appealed\n    * _Judges in the Supreme Court, temporary and permanent positions_\n    * _Judges in the Court of Appeal (only employees in the judicial system, not lay judges/alternate judges), temporary and permanent positions_\n    * _Norwegian judges at international courts, e.g., the European Court of Human Rights (ECHR), the EFTA Court, the UN Court (ICJ)_\n* Member of the board of of national audit, audit court or central bank\n    * _Members and alternate members of the board of auditors in the National Audit Office_\n    * _Board of directors of Norges Bank_\n* Ambassador or chargé d'affaires \n    * _Norwegian ambassador or chargé d'affaires at a Norwegian embassy (consuls are not included)_\n* High-ranking military officer \n    * _Chief of Defense_\n    * _Leaders in the various branches of defense: general, lieutenant general, and major general (equivalent to admiral, vice admiral, and rear admiral in the navy)_\n* Member of an administrative, managerial or controlling body of a “state enterprise”*\n    * _Board of directors and CEO in state enterprises_\n`*`_\"State enterprises\" are state-owned companies responsible for public tasks falling within the public administration. The decisive factor is whether they involve state authorities, even if represented by a corporation. State-owned companies that do not perform tasks involving public administration fall outside the definition._\n_Excludes subsidiaries, self-owned institutions (typically foundations) wholly or partially financed by public funds, local enterprises (such as county and municipal enterprises)_\n\n* Director, board member or other person in the senior management of an international organization\n    * _Persons nominated, appointed, or employed by a government, department, or minister in an international organization established by entering into a formal international political agreement, e.g., EFTA, NATO, and the UN (non-profit organizations are not included)._\n\n**Who is defined as a closely related family member to a PEP?**\n\n\n\n* Parents\n* Spouse, registered partner, or cohabitant \n* Children, as well as the children's spouse, registered partner, or cohabitant \n\nSiblings, stepchildren, and stepparents are not included in the definition. Adopted children are considered equal to biological children.\n\n**Who is defined as a known associate of a PEP?**\n\nA known associate is defined as a person known to:\n\n\n\n* have joint beneficial ownership of a company with a politically exposed person\n* Have a close business relationship with a politically exposed person\n* Be the sole beneficial owner of a company established in reality to benefit a politically exposed person\n\n_More information in the [guidance to the Anti-Money Laundering Act](https://www.finanstilsynet.no/nyhetsarkiv/rundskriv/2022/veileder-til-hvitvaskingsloven/)._",
    "matches.help-text.pep.title": "How to assess PEP matches?",
    "matches.labels.details": "What is the match about?",
    "matches.labels.negative-news": "Adverse media",
    "matches.labels.negative-news.helper-text-company": "The company is linked to adverse media that could indicate a higher risk",
    "matches.labels.negative-news.helper-text-person": "The person is linked to adverse media that could indicate a higher risk",
    "matches.labels.other": "Other",
    "matches.labels.other.helper-text-company": "The company is linked to other types of events (describe in the free text field)",
    "matches.labels.other.helper-text-person": "The person is linked to other types of events (describe in the free text field)",
    "matches.labels.pep": "PEP",
    "matches.labels.pep.detailed": "PEP (Politically Exposed Person)",
    "matches.labels.pep.detailed.tooltip": "Politically exposed persons (PEP) are persons who hold a special public office and may therefore be exposed to bribery and other corruption",
    "matches.labels.pep.helper-text": "The person in question is a politically exposed person, or closely related to one (according to the definition in the Anti-Money Laundering Act)",
    "matches.labels.rejected-by": "Rejected by {name}, {timestamp, date, ::yyyyMMdd}",
    "matches.labels.relations": "Relationships / affiliations",
    "matches.labels.review.description": "Rationale",
    "matches.labels.review.description.placeholder": "Review description",
    "matches.labels.sanction": "Sanction",
    "matches.labels.sanction.helper-text-company": "The company is sanctioned and listed in the sanctions list",
    "matches.labels.sanction.helper-text-person": "The person is sanctioned and listed in the sanctions list",
    "matches.labels.sanctions": "Sanctions",
    "matches.labels.source": "Source: ",
    "matches.labels.source.name": "Source name: ",
    "matches.labels.source.publication-source": "Publication source:",
    "matches.labels.source.publisher": "Publisher:",
    "matches.labels.source.url": "Source:",
    "matches.navigation.tooltip": "{summary} on {name}",
    "matches.review.approved": "Match confirmed",
    "matches.review.denied": "Match denied",
    "matches.text.no.confirmed.matches": "No confirmed matches",
    "matches.text.no.matches": "No matches found 🎉",
    "matches.title.compare.companies": "Compare companies",
    "matches.title.compare.persons": "Compare persons",
    "matches.title.details.matches": "Matches during screening",
    "matches.titles.assessment": "Review screening match",
    "matches.titles.categories": "CATEGORIES",
    "matches.titles.comments": "COMMENTS",
    "matches.titles.company-customer": "Company details",
    "matches.titles.data-source": "Match from data source",
    "matches.titles.events": "EVENTS",
    "matches.titles.geographic-affiliation": "Geographic affiliation",
    "matches.titles.key-information": "Key Information",
    "matches.titles.listings": "LISTINGS",
    "matches.titles.matches-against-data-source": "MATCH AGAINST DATA SOURCE",
    "matches.titles.person-customer": "Personal details",
    "matches.titles.positions": "POSITIONS",
    "matches.titles.relations": "RELATIONS",
    "matches.titles.relevant-links": "RELEVANT LINKS",
    "matches.titles.sources": "SOURCES",
    "matches.titles.summary": "SUMMARY",
    "measures-settings.page.description": "Here you can create measures that you can use in the risk assessment of your customers.",
    "measures-settings.page.filter.hide-archived-measures": "Hide inactive measures",
    "measures-settings.page.filter.show-archived-measures": "Show inactive measures",
    "measures-settings.page.title": "Measures",
    "measures.confirm-archive.description": "Are you sure you want to archive «{name}»?.\nThis will not remove existing measures.",
    "measures.confirm-archive.labels.archive.button": "Archive measure",
    "measures.confirm-archive.title": "Archive Measure",
    "measures.confirm-remove.description": "Are you sure you want to remove the measure?",
    "measures.confirm-remove.title": "Remove measure",
    "measures.errors.empty-measure": "Measure is empty",
    "measures.list.loading.error-action": "Get measures list",
    "measures.list.loading.label": "Loading measures",
    "measures.modal.empty-state": "There are currently no measures",
    "measures.modal.errors.description-validation-error": "Description required",
    "measures.modal.errors.title-not-unique-validation-error": "Title already exists",
    "measures.modal.errors.title-validation-error": "Title required",
    "measures.modal.title.add": "Add Measure",
    "measures.modal.title.update": "Edit Measure",
    "measures.modal.title.view": "Measure",
    "measures.popover.labels.button": "Add measure",
    "measures.popover.labels.filter": "Add new measure",
    "measures.popover.labels.global-list.empty": "There are no existing measures",
    "measures.popover.labels.global-list.title": "Choose existing measures",
    "measures.popover.labels.new-empty-measure": "New measure",
    "menu.import.companies": "Import Companies",
    "menu.language.english": "Language: English",
    "menu.language.norwegian": "Language: Norwegian",
    "menu.logout": "Log out",
    "menu.plan-upgrade": "AML-package: {packageName}",
    "menu.settings": "Settings",
    "menu.support-email": "Contact support",
    "menu.whats-new": "What's new?",
    "missing-required-permission.banner.description": "Only {roles} can change these settings",
    "modals.company.edit.title": "Edit company details",
    "modals.copy.link.button": "Copy link",
    "modals.copy.link.button.copied": "Copied",
    "modals.delete.signature.button": "Delete KYC request",
    "modals.delete.signature.description": "Are you sure you want to delete the KYC request to {name}?",
    "modals.delete.signature.title": "Delete KYC request",
    "modals.headings.address": "Address",
    "modals.headings.personal-information": "Personal Information",
    "modals.owner.confirm.archive.description": "Are you sure you want to archive {owner}?",
    "modals.owner.confirm.archive.title": "Archive owner",
    "modals.owner.headings.ownership-in-company": "Ownership in company",
    "modals.owner.labels.percent_share": "Ownership share in %",
    "modals.owner.messages.owner-restored": "Owner «{name}» was restored",
    "modals.owner.title.add": "Add owner",
    "modals.owner.title.update": "Update owner",
    "modals.owner.tooltips.archive-disabled": "You can't archive an owner that is being screened",
    "modals.person.edit.title": "Edit person details",
    "modals.remind.signer.button": "Send reminder",
    "modals.remind.signer.title": "Send reminder to receiver",
    "modals.role.confirm.delete.description": "Are you sure you want to delete {role} from the list of role holders?\nThis action cannot be undone.",
    "modals.role.confirm.delete.title": "Delete role holder",
    "modals.role.headings.role-in-company": "Role in company",
    "modals.role.labels.role_type": "Role",
    "modals.role.labels.select.placeholder": "Choose role type",
    "modals.role.title.add": "Add role holder",
    "modals.role.title.update": "Update role holder",
    "modals.role.tooltips.delete-disabled": "You can't delete a role that is being screened",
    "modals.update.signature.button": "Save changes",
    "modals.update.signature.customer": "CUSTOMER",
    "modals.update.signature.error.duplicate-email": "This email is already used for another recipient",
    "modals.update.signature.title": "Edit recipient info",
    "nav-bar.dashboard": "Dashboard",
    "nav-bar.new-customer": "Register customer",
    "nav-bar.new-customer.company": "Company customer",
    "nav-bar.new-customer.person": "Person customer",
    "nav-bar.overview": "Customers",
    "navigation.page.customers.title": "Customers",
    "navigation.settings.checklists.label": "Checklists",
    "navigation.settings.internal-tools.kyc-previewer.label": "KYC Previewer",
    "navigation.settings.internal-tools.section.title": "Internal Tools",
    "navigation.settings.kyc.auto-reminder.label": "KYC reminders of customers",
    "navigation.settings.kyc.custom-questionnaires.label": "Create KYC-questions",
    "navigation.settings.notifications.customer-info.label": "Company updates",
    "navigation.settings.notifications.section.title": "Notifications",
    "navigation.settings.onboarding.person.title": "Person customer",
    "navigation.settings.onboarding.section.title": "Customer registration",
    "navigation.settings.risk-management.section.title": "Risk management",
    "navigation.settings.users.section.title": "Users management",
    "navigation.settings.users.title": "All users",
    "new-company-customer.country-options.no": "Norwegian company",
    "new-company-customer.country-options.other": "Foreign company",
    "new-company-customer.texts.manual": "Fill in the company's information manually",
    "new-company-customer.titles.manual": "Register foreign company",
    "new-company-customer.titles.norwegian": "Register Norwegian company",
    "not-found.description": "This page may have been moved, deleted, or perhaps there is an error in the url",
    "not-found.title": "Hmm, this page has gone missing",
    "not.specified": "Not specified",
    "notifications-settings.followup.form.label": "How often would you like to receive email notifications?",
    "notifications-settings.followup.form.label.monthly": "Once a month",
    "notifications-settings.followup.form.label.no-notification": "No notifications",
    "notifications-settings.followup.form.label.weekly": "Once a week",
    "onboarding-settings.page.description": "Here you can choose which settings will apply to the registration of all new customers. Your choices will then be pre-filled for new customer registrations.",
    "onboarding-settings.page.title": "Onboarding of personal customers",
    "onboarding-summary.signature-table-column.content-language": "CONTENT LANGUAGE",
    "onboarding-summary.signature-table-column.email-or-url": "EMAIL/LINK",
    "onboarding-summary.signature-table-column.name": "NAME",
    "onboarding-summary.signature-table-column.scope": "SCOPE",
    "onboarding-summary.title": "Summary",
    "onboarding.assignments-and-attachments.description": "Create an assignment for the customer and upload the necessary documents related to the assignment or customer relationship.",
    "onboarding.assignments-and-attachments.title": "Assignment and documents",
    "onboarding.assignments.description": "Create an assignment for the customer",
    "onboarding.assignments.title": "Assignment",
    "onboarding.associated-project.title": "Associated project",
    "onboarding.bar.company.assignments-and-attachments.title": "Assignment and attachments",
    "onboarding.bar.company.assignments.title": "Assignment",
    "onboarding.bar.company.disclosures.title": "KYC",
    "onboarding.bar.company.screening.title": "Screening",
    "onboarding.bar.company.summary.title": "Summary",
    "onboarding.bar.manual-company.information.title": "Information",
    "onboarding.cancel.and.delete": "Abort registration",
    "onboarding.cancel.and.save": "Save and continue later",
    "onboarding.cancel.confirm.description": "Are you sure you want to cancel the registration of {name}?\nIf you cancel the registration, {name} will be deleted, and you will have to perform the registration again.",
    "onboarding.cancel.confirm.title": "Cancel registration",
    "onboarding.cancel.onboarding": "Close",
    "onboarding.disclosures.company-description": "You are obligated to assess the person/persons that are acting on behalf of the customer, according to the Money Laundering Act. Choose the concerned ones.",
    "onboarding.disclosures.duplicate.emails.error": "Det er tastet inn samme e-postadresse til flere personer. Se over e-postadressene.",
    "onboarding.disclosures.person-description": "You are obligated to assess your customer, according to the Money Laundering Act.",
    "onboarding.disclosures.person.require-disclosure": "Identify and/or send KYC questions",
    "onboarding.disclosures.send-email.text": "A unique link for electronic identification will be created, which will be available from the customer page. You are responsible for sending the link to the person concerned.",
    "onboarding.disclosures.title": "Identification and KYC questions",
    "onboarding.new.person.title": "Onboard Person",
    "onboarding.screening-type.monitoring.helper.text": "Notifications will be continuously provided if the following people are flagged against PEP and/or sanctions lists, as well as adverse media articles.",
    "onboarding.screening-type.one-time.helper.text": "Screens the customer one time against PEP and sanctions lists, as well as adverse media articles, before the customer relationship is up for review. Notifications will not be given regarding changes in owners or the control structure.",
    "onboarding.status.draft-review": "Draft {count, plural, =1 {review} other {reviews}}",
    "onboarding.status.ready-for-review": "Ready for review",
    "onboarding.status.started": "Started",
    "outstanding-shares.banner.description": "The shareholder register lacks information about <bold>{outstandingShares, number}</bold> shares of <bold>{totalShares, number}</bold>.\nIt is therefore recommended to contact the customer to obtain a complete share register.\nAfterwards, the undisclosed information about owners and real rights holder(s) can be updated manually below.",
    "outstanding-shares.banner.title": "Outstanding shares",
    "owners.card.buttons.add-owner": "Add beneficial owner",
    "owners.card.cannot-have-shareholders": "This company type ({companyType}) cannot have shareholders, so we do not identify owners with shares for this company.",
    "owners.card.manual.no-owners": "No owners.",
    "owners.card.newly-founded.no-owners": "This company was founded after the Norwegian Aksjonærregisteret was updated (December 31).\nCheck whether the customer has provided correct/updated information in the KYC form after the KYC form has been answered.",
    "owners.card.no-owners": "There are no owners who own/control (directly or indirectly) 5 percent or more (source: Norwegian Aksjonærregisteret)",
    "ownership-update.actions.labels.confirm-all-updates": "Confirm all changes",
    "ownership-update.actions.labels.ignore": "Ignore",
    "ownership-update.banner.description": "We have received important updates that affect the ownership of this customer. \nThe information is taken from the Norwegian Shareholder Register {year}, and thus reflect the ownership as it was at the end of {year}. You have to approve or ignore the changes.",
    "ownership-update.banner.finished.description": "There are no more ownership updates! 🎉",
    "ownership-update.confirm-all.modal.action.label": "Go to screening settings",
    "ownership-update.confirm-all.modal.content": "This does not affect the screening. You must change this manually if necessary, e.g. if new owners should be screened, or expired owners should be removed from screening.",
    "ownership-update.confirm-all.modal.title": "Great! Then it’s done! 🎉",
    "ownership-update.description.update": "Last updated from The shareholder register {year}",
    "ownership-update.info.label": "Ownership updates",
    "ownership-update.reject.confirmation.modal.action.label": "Ignore change",
    "ownership-update.reject.confirmation.modal.content.add": "Ignoring the change is deleted <bold>{name}</bold> from the list of licensees.",
    "ownership-update.reject.confirmation.modal.content.delete": "Ignoring the change maintains location <bold>{name}</bold> in the list of licensees.",
    "ownership-update.reject.confirmation.modal.content.update": "By ignoring the change, the ownership share is added <bold>{name}</bold> back to {value}.",
    "ownership-update.reject.confirmation.modal.title": "Are you sure you want to ignore the change?",
    "ownership.view.table": "Owners",
    "ownership.view.tree": "Ownership structure",
    "ownership.view.tree.info": "Information is taken directly from Aksjonærregisteret. We include all individuals with ownership of at least 5%, or chains of ownership of at least 25%.",
    "pending-tasks.labels.awaiting-disclosures": "Awaiting answer on {count, plural, =1 {1 KYC request} other {# KYC requests}}",
    "pending-tasks.labels.awaiting-documents": "Awaiting completion of {count, plural, =1 {1 e-signature request} other {# e-signature requests}}",
    "pending-tasks.labels.open-matches": "Awaiting review of {count, plural, =1 {1 match} other {# matches}}",
    "pending.tasks.labels.approve-review": "Approve customer review",
    "pending.tasks.labels.days-since-onboarding": "{days, plural, =0 {request sent today} =1 {1 day since request} other {# days since request}}",
    "pending.tasks.labels.finish-onboarding": "Continue registering",
    "pending.tasks.labels.followup-customer": "Follow-up customer",
    "pending.tasks.labels.open-draft-review": "Open draft review",
    "pending.tasks.labels.remind-recipients": "Remind recipients",
    "pending.tasks.labels.review-customer": "Review customer",
    "pending.tasks.labels.review-matches": "Review {count, plural, =1 {match} other {matches}}",
    "pending.tasks.labels.review-measures": "Review {count, plural, =1 {measure} other {measures}}",
    "pending.tasks.labels.review-ownership-updates": "Review ownership updates",
    "pending.tasks.labels.see-draft-reviews": "See draft reviews",
    "pending.tasks.labels.see-pending-disclosures": "See {count, plural, =1 {request} other {requests}}",
    "pending.tasks.labels.see-pending-documents": "See {count, plural, =1 {document} other {documents}}",
    "pending.tasks.status.approve-review": "Approve/Reject review",
    "pending.tasks.status.followup": "Follow-up: {days, plural, =-1 {expired} =0 {today} =1 {in 1 day} other {in # days}}",
    "pending.tasks.status.review-measures": "{count, number} pending {count, plural, =1 {measure} other {measures}}",
    "pending.tasks.status.waiting-for-approval": "Pending review approval",
    "pending.tasks.status.waiting-for-approval.subtitle": "Requested on {timestamp, date, ::yyyyMMdd} from {names}",
    "person-name.description.manually-created": "Created by {name}, {timestamp, date, ::yyyyMMdd}",
    "person.customer.details.personal.number": "Personal number",
    "person.details.caption.address": "ADDRESS",
    "person.details.caption.birth.date": "BIRTHDATE",
    "person.details.caption.citizenship": "CITIZENSHIP",
    "person.details.caption.externalId": "ID",
    "person.details.caption.first.name": "FIRST NAME",
    "person.details.caption.last.name": "LAST NAME",
    "person.details.caption.origin": "COUNTRY OF BIRTH",
    "person.details.caption.person.number": "PERSONAL NUMBER",
    "person.details.caption.residence": "COUNTRY OF RESIDENCE",
    "person.details.title": "person details",
    "personal.number.placeholder.no": "ddmmyyXXXXX",
    "plan-conversion.add-to-projects.description": "Upgrade your AML plan to enable projects.",
    "plan-conversion.attachments.description": "Upgrade your AML package to access document upload and email signing.",
    "plan-conversion.banner.labels.link": "See the different AML packages",
    "plan-conversion.customer-action.label": "Upgrade your AML plan for this function",
    "plan-conversion.messages.access-feature": "Oppgrader din AML-pakke for å få tilgang til denne funksjonen.",
    "plan-conversion.modal.title": "Upgrade your AML package",
    "plan-conversion.projects.description": "Projects is a function that lets you gather several customers in one overview. This makes it easy to have full overview of all customers that belong to the same project.",
    "plan-conversion.projects.image.alt-text": "Project details image",
    "project.actions.labels.edit": "Edit project details",
    "project.actions.labels.end-project": "End project",
    "project.actions.labels.reactivate": "Reactivate project",
    "project.banner.vitec.imported.text": "Start with registering the customer. The customer report is automatically uploaded to Vitec when reviewing a customer.",
    "project.banner.vitec.label": "This project is imported from Vitec",
    "project.button.imported-from-vitec": "Vitec",
    "project.customers.actions.remove-from-project": "Remove from project",
    "project.customers.buttons.add-customers": "Add customers",
    "project.customers.buttons.add-existing-customers": "Add existing customers",
    "project.customers.buttons.add-new-company-customer": "Add new company",
    "project.customers.buttons.add-new-person-customer": "Add new person",
    "project.customers.empty.header": "No customers are listed in this project.",
    "project.customers.empty.message": "Add customers to the project by pressing the \"Add customers\" button above.",
    "project.customers.modal.title": "Add customers to project «{name}»",
    "project.customers.title": "Customers in project",
    "project.details.labels.description": "Add project description",
    "project.details.labels.name": "Enter project name",
    "project.end.confirmation.action.label": "End project «{name}»",
    "project.end.confirmation.description": "Are you sure you want to end project «{name}» ?",
    "project.end.confirmation.title": "End project",
    "project.info.labels.created": "Created",
    "project.info.labels.description": "Description",
    "project.info.labels.project-managers": "Project managers",
    "project.info.labels.status": "Status",
    "project.info.manager.empty.user": "Select project manager",
    "project.info.manager.error": "Failed to assign new project manager",
    "project.notes.placeholder": "Leave a note about the project",
    "project.remove-customers.confirmation.action.label": "Remove customers",
    "project.remove-customers.confirmation.description": "Are you sure you want to remove {names} from project «{projectName}» ?",
    "project.remove-customers.confirmation.title": "Remove customers",
    "project.remove-customers.success.message": "Removed {count, plural, =1 {customer} other {# customers}}",
    "project.status.ACTIVE": "Active",
    "project.status.INACTIVE": "Inactive",
    "project.vitec.customers.empty.message": "Add customers to the project by pressing the Vitec link.",
    "projects.common.labels.create.project": "Create Project",
    "projects.common.labels.update.project": "Update Project",
    "projects.list.column.name": "PROJECT NAME",
    "projects.list.column.status": "STATUS",
    "projects.list.empty.projects.header": "You have not created any projects yet.",
    "projects.list.empty.projects.message": "Create your first project by pressing the button in the top right corner.",
    "projects.list.filters.search.hint": "Search projects",
    "projects.modal.empty.search.description": "Check if you have typed correctly, or add the customer directly from the project",
    "projects.modal.empty.search.title": "Unfortunately, we could not find this project",
    "projects.modal.filters.search.hint": "Search for project",
    "projects.modal.success.message": "{count, plural, =1 {1 customer} other {# customers}} added to project",
    "projects.modal.title": "Add to project",
    "projects.page.header.projects.count": "Number of projects: {count} {selected, plural, =0 {} other {, # selected}}",
    "projects.page.title": "Projects",
    "question.editor.buttons.delete.label": "Delete question",
    "question.editor.errors.duplicate-question": "The same question already exists",
    "question.editor.errors.empty-question": "Write a question",
    "question.editor.questions-table.empty.label": "You have not yet added any questions to this list",
    "questionnaire.archive.confirmation.description": "Are you sure you want to archive the questionnaire \"{name}\"?",
    "questionnaire.archive.confirmation.title": "Archive questionnaire",
    "questionnaire.choices-table.button.add.label": "Add answer option",
    "questionnaire.choices-table.description.label": "Answer option {index}",
    "questionnaire.choices-table.errors.empty-option": "Empty option",
    "questionnaire.details.page.invalid": "Invalid questionnaire",
    "questionnaire.details.page.title.new-questionnaire": "Create your own KYC-questions",
    "questionnaire.page.add-questionnaire.button.label": "Create KYC-questions",
    "questionnaire.page.filter.hide-archived-questionnaires": "Hide archived questionnaires",
    "questionnaire.page.filter.placeholder": "Filter custom questionnaires by name",
    "questionnaire.page.filter.show-archived-questionnaires": "Show archived questionnaires",
    "questionnaire.page.header.description": "The KYC form you send to your customers consists of predefined questions tailored to your industry. Here you have the opportunity to create custom questionnaires that can be sent to your customers, either together with the industry-tailored KYC form, or alone",
    "questionnaire.page.title": "Create your own KYC-questions",
    "questionnaire.preview.modal.title": "Preview questionnaire \"{name}\"",
    "questionnaire.question.description.label": "Question in {language}",
    "questionnaire.question.type.boolean": "Yes/No",
    "questionnaire.question.type.multiple-choice": "Multiple choice",
    "questionnaire.question.type.multiple-country-choice": "Multiple countries",
    "questionnaire.question.type.single-choice": "Single choice",
    "questionnaire.question.type.single-country-choice": "Single country",
    "questionnaire.question.type.text": "Text field",
    "questionnaire.title.label": "Title in {language}",
    "questions.editor.buttons.add-question.label": "Add question",
    "responsible-users.label": "Responsible users",
    "responsible.empty.users": "Select responsible users",
    "responsible.error": "Failed to assign responsible users",
    "responsible.label": "Responsible user",
    "responsible.modal.message": "Set responsible users for {names}",
    "responsible.modal.title": "Set Responsible Users",
    "review.checklist.answer.error.empty-additional-info": "You must enter a description in the text field above",
    "review.checklist.answer.placeholder": "Elaborate here:",
    "review.checklist.details.page.messages.created-successfully": "The review checklist «{name}» was created successfully",
    "review.checklist.details.page.title.edit-checklist": "Edit checklist",
    "review.checklist.details.page.title.new-checklist": "Create checklist",
    "review.checklist.duplicate.modal.success.message": "The checklist was copied and saved as «{name}»",
    "review.checklist.duplicate.modal.title": "Make a copy of checklist «{name}»",
    "review.checklist.editor.condition-type.purpose": "Assignment type",
    "review.checklist.editor.condition-type.risk": "Risk category",
    "review.checklist.editor.condition-type.tags": "Tags",
    "review.checklist.editor.empty.name": "You need to give the check list a name",
    "review.checklist.editor.labels.customer-type": "The checklist should apply to:",
    "review.checklist.editor.labels.required": "Should the checklist be mandatory?",
    "review.checklist.editor.labels.risk-type": "What conditions should trigger the checklist to be added?",
    "review.checklist.editor.labels.selection-type": "Should the checklist be automatically added to the risk review?",
    "review.checklist.editor.labels.yes-always": "Yes, always",
    "review.checklist.editor.labels.yes-choose": "Ja, select condition",
    "review.checklist.editor.selection-type.always": "Always",
    "review.checklist.editor.selection-type.automatic": "Automatically",
    "review.checklist.editor.selection-type.manual": "Manually",
    "review.checklist.editor.tips.banner.description": "1. Give the checklist a name and description, as well as which customer type it should apply to.\n2. Select whether it should be added automatically to the risk assessment, or select what should trigger the checklist. \n3. Select whether the checklist should be mandatory for all users.\n4. Add questions and formulate these as \"Yes\"/\"No\" questions\n5. If \"Yes\", it is required for the case manager to elaborate further\n6. Click the \"Preview\" button to display the checklist as it will appear in the actual risk assessment",
    "review.checklist.editor.tips.banner.title": "Creation of checklists",
    "review.checklist.preview.modal.title": "Preview checklist «{name}»",
    "review.checklist.template.instance.modal.title": "Create a checklist from template: {name}",
    "review.checklist.template.preview.modal.title": "Preview template: {name}",
    "review.checklists.archive.confirmation.description": "Are you sure you want to archive the checklist «{name}»?",
    "review.checklists.archive.confirmation.title": "Archive checklist",
    "review.checklists.page.add.button.label": "Create checklist",
    "review.checklists.page.filter.hide-archived-checklists": "Hide archived checklists",
    "review.checklists.page.filter.placeholder": "Filter review checklists by name",
    "review.checklists.page.filter.show-archived-checklists": "Show archived checklists",
    "review.checklists.page.header.description": "Here you can create your own checklists that can be used in the risk assessment of your customers.\nYou can create new checklists, or take a template and adapt it to your business.",
    "review.checklists.page.table.header": "My checklists",
    "review.checklists.page.title": "Custom Checklists",
    "review.status.APPROVED": "Approved",
    "review.status.NOT_READY": "Not ready - screening in progress",
    "review.status.REJECTED": "Rejected",
    "review.status.REVIEW_REQUIRED": "Review required",
    "reviews.approval-form.title": "Review approval",
    "reviews.header.banner.pending-disclosures.button.label": "See remaining pending KYC and identification {count, plural, =1 {request} other {requests}}",
    "reviews.header.banner.pending-disclosures.description": "There {count, plural, =1 {is 1} other {are #}} pending KYC and identification {count, plural, =1 {request} other {requests}}. These may provide information that affects how you want to risk assess your customer",
    "reviews.header.banner.unreviewed-match-cases.button.label": "See remaining {count, plural, =1 {match} other {matches}}",
    "reviews.header.banner.unreviewed-match-cases.description": "There {count, plural, =1 {is 1 possible match} other {are # possible matches}} that should be reviewed before you can review your customer",
    "reviews.header.title": "Reviews",
    "reviews.labels.ask-for-confirmation": "Ask for confirmation",
    "reviews.labels.change-review": "New review",
    "reviews.labels.customer-risk": "The customer belongs to a risk exposed industry",
    "reviews.labels.mark-as": "Mark customer as",
    "reviews.labels.mark-as.pep": "PEP",
    "reviews.labels.mark-as.sanction": "Sanction",
    "reviews.labels.new-review": "New review",
    "reviews.labels.no-reviews": "There are no reviews on the customer or associated assignments",
    "reviews.labels.perform-a-review": "Perform a review",
    "reviews.labels.relationship.change": "Assign risk",
    "reviews.labels.review-header": "Review",
    "reviews.labels.review-label": "Rationale",
    "reviews.labels.review.assessment": "Approve/Reject review",
    "reviews.labels.risk-indicators": "Risk indicators{count, plural, =0 {} other {: #}}",
    "reviews.labels.risk-tags": "Organize with tags",
    "reviews.labels.select-user-for-confirmation": "Select user for confirmation",
    "reviews.labels.toggle.hide-previous": "Hide previous reviews ({count, number})",
    "reviews.labels.toggle.show-previous": "Show previous reviews ({count, number})",
    "reviews.labels.unmark-as": "Unmarked as {badges}",
    "reviews.placeholders.review-rational": "Explain rationale for the review that has been made",
    "reviews.titles.checklist": "Customer Review Checklist",
    "reviews.titles.existing-reviews": "Existing reviews",
    "reviews.titles.guideline-tips": "Tips on what a good review should contain",
    "reviews.titles.review-customer": "Review Customer",
    "reviews.titles.risk-review": "Risk review",
    "risk-indicators.geographic-risk.description": "Person(s) responsible for reporting, in accordance with the money laundering act § 4-10, should conduct enhanced due diligence for customers and ultimate beneficial owners which are established in high risk countries.",
    "risk-indicators.geographic-risk.title": "{country} found in the following list(s) of high risk countries: {listNames}",
    "risk-indicators.labels.confirmed-matches": "CONFIRMED MATCHES: {count, number}",
    "risk-indicators.labels.disclosure-risk": "KYC ANSWERS{count, plural, =0 {} other {: #}}",
    "risk-indicators.labels.geographic-risk": "GEOGRAPHIC RISK{count, plural, =0 {} other {: #}}",
    "risk-indicators.labels.industry-risk": "INDUSTRY RISK{count, plural, =0 {} other {: #}}",
    "risk-indicators.labels.personnel-risk": "ROLES AND OWNERS RISK{count, plural, =0 {} other {: #}}",
    "risklabel.HIGH": "High",
    "risklabel.LOW": "Low",
    "risklabel.MEDIUM": "Medium",
    "risklabel.NOT_SET": "Not Set",
    "risklabel.null": "Not Set",
    "roles.button.labels.hide-expired-roles": "Hide expired roles",
    "roles.button.labels.show-expired-roles": "Show expired roles ({count, number})",
    "roles.messages.no-roles": "No roles",
    "screening-type.MONITORING": "Continuous",
    "screening-type.NONE": "NONE",
    "screening-type.NOT_SET": "NONE",
    "screening-type.ONE_TIME": "One time",
    "screening-type.label.monitoring": "Continuous",
    "screening-type.label.one-time": "One time",
    "screening-type.modal.message": "Enter screening settings for {names}",
    "screening-type.modal.title": "Choose screening",
    "screening-type.tooltip.person.screening.monitoring": "The person is set to continuous screening",
    "screening-type.tooltip.person.screening.none": "The person is not set to continuous screening",
    "screening.buttons.add-role": "Add role",
    "screening.errors.content": "Try again a bit later",
    "screening.errors.description": "Give it a few seconds and try again. Or go get yourself a coffee :)",
    "screening.errors.heading": "Sorry, this is taking way too long...",
    "screening.infobox.owners.definition": "An (ultimate) beneficial owner is a person who, alone or together with others, can exercise (ultimate) effective control over the company. There are several examples of this:\n\n• A person who alone holds more than 25% of the shares/votes\n\n• Family members who together (directly or indirectly) hold more than 25% of the shares/votes\n\n• A person who, via special articles of association, shareholder agreement(s) or other agreements, controls the company.\n\nYou can read more about identifying beneficial owners in the Norwegian Money Laundering Act: https://lovdata.no/lov/2018-06-01-23/§14",
    "screening.infobox.owners.text.manual": "Beneficial owners must be added manually when registering foreign companies.",
    "screening.infobox.owners.text.norwegian": "For companies that can have shareholders, we identify natural persons who own 5 percent or more throughout the ownership structure (source: Norwegian Aksjonærregisteret). You are responsible for verifying these, and, if needed, update and/or add missing beneficial owners.",
    "screening.infobox.owners.title": "What is a beneficial owner?",
    "screening.infobox.roles.definition": "A role holder is a person who holds a role in the company. Examples of this are board members, CEO, and persons who can sign on behalf of the company (have signature/power of attorney rights).",
    "screening.infobox.roles.text.manual": "Role holders must be added manually when registering foreign companies.",
    "screening.infobox.roles.text.norwegian": "We identify persons who, at the time of registration, is registered with roles in the company (source: Brønnøysundregistrene).",
    "screening.infobox.roles.title": "What is a role?",
    "screening.messages.retrieving-details": "Retrieving customer data",
    "screening.messages.specify-owners": "Specify beneficial owners in the company",
    "screening.messages.specify-roles": "Specify roles in the company",
    "screening.owners.is_ubo.description": "This person owns more than 25% of the shares in the company (or owns more than 25% of the shares in a company that owns more than 25% of the shares of the customer, etc.), which indicates that the person can be regarded as an ultimate beneficial owner (UBO). See the Norwegian Money Laundering Act: https://lovdata.no/lov/2018-06-01-23/§14",
    "screening.roles.is_ubo.description": "Because of the company type ({companyType}), this role ({roleType}) may be considered an alternative UBO.",
    "screening.snackbar.started": "New screening started",
    "screening.snackbar.stopped": "Screening control stopped",
    "screening.snackbar.updated": "Screening control updated",
    "screening.status.active": "Active",
    "screening.status.finished": "(performed {finished, date, ::yyyyMMdd})",
    "screening.status.range": "(started {started, date, ::yyyyMMdd}, stopped {stopped, date, ::yyyyMMdd})",
    "screening.titles.banner.description": "The customer will not be notified that you are conducting a customer check.",
    "screening.titles.banner.title": "Screening is made unnoticed.",
    "screening.titles.customer": "Customer",
    "screening.titles.owners": "Beneficial owners",
    "screening.titles.roles": "Roles",
    "screening.titles.screening": "Screening",
    "screening.titles.screening-frequency": "Choose the frequency of screening",
    "screening.titles.screening.description": "Select the people to be included in the screening. The people presented consist of shareholders with a 5 percent or higher shareholding and identified role holders of the company you are going to register.",
    "screening.titles.screening.manual.description": "Add owners and roles to the company customer you are registering. Remember to check all you want to include in the screening.",
    "screening.titles.screening.without-shareholders.description": "Select the people to be included in the screening. The people presented consist of identified role holders of the company you are going to register.",
    "shares-classes.banner.description": "There are different share classes in {name}. Please note that a person may have voting rights in the customer beyond those resulting from the ownership stake when different share classes with different voting rights have been issued (e.g. A and B shares). This may have an impact on who is to be regarded as the ultimate beneficial owner(s). You should therefore obtain the articles of association from your customer and examine this.",
    "shares-classes.banner.title": "Several share classes identified: {shares}",
    "shares-classes.banner.url-label": "Read more on our support portal",
    "signature.actions.copy.link": "Copy link",
    "signature.actions.delete.signature": "Delete KYC request",
    "signature.actions.edit.signature": "Edit recipient info",
    "signature.actions.remind.signer": "Remind recipient",
    "signature.configuration.form.buttons.preview": "See how the KYC looks for the customer",
    "signature.configuration.form.labels.choose.language": "Select language for emails and KYC questions",
    "signature.configuration.form.labels.choose.send.method": "Select send method",
    "signature.configuration.form.labels.custom.kyc.questions": "Custom KYC questions",
    "signature.configuration.form.labels.disclosure": "KYC questions",
    "signature.configuration.form.labels.disclosure.full": "Full (inc. PEP questions)",
    "signature.configuration.form.labels.disclosure.pep": "PEP questions only",
    "signature.configuration.form.labels.e-signatures": "Send document for e-signing",
    "signature.configuration.form.labels.preview": "Preview of KYC",
    "signature.configuration.form.labels.verification": "Include credentials with:",
    "signature.email.not.provided": "Link available on customer page",
    "signature.modal.and.tooltips.copy.link": "Copy signing link",
    "signature.signing-method.no": "Norwegian BankID",
    "signature.signing-method.se": "Swedish BankID",
    "signature.snackbar.deleted": "KYC request deleted",
    "signature.tooltips.remind.signer": "Remind signer",
    "signing-user-info.address": "Address",
    "signing-user-info.birth-date": "Date of birth",
    "signing-user-info.name.mismatch.warning.tooltip": "Is this the right person?",
    "summary.description": "Look over the summary and make changes if necessary. When you start the screening, the customer will receive a link with electronic identification and a customer questionnaire.",
    "summary.project.title": "Project",
    "summary.responsible-user": "Responsible user",
    "summary.screening-type": "Screening type",
    "summary.signers.start.screening": "Register customer and start screening",
    "summary.signers.text.skipped": "This step was skipped",
    "summary.signers.title": "Recipients of credentials and KYC questions",
    "summary.signers.title.empty": "No representatives selected",
    "summary.text.no-owners": "No owners will be screened",
    "summary.text.no-roles": "No roles will be screened",
    "summary.text.screening.company": "Screening of company",
    "summary.text.screening.owners": "Screening of owners",
    "summary.text.screening.roles": "Screening of roles",
    "table.column.active": "ACTIVE",
    "table.column.address": "ADDRESS",
    "table.column.country": "COUNTRY",
    "table.column.customer-number": "PERSONAL NUMBER / ORG.NR",
    "table.column.customerTypes": "CUSTOMER TYPES",
    "table.column.date.of.birth": "DATE OF BIRTH",
    "table.column.details": "DETAILS",
    "table.column.email": "EMAIL",
    "table.column.email.or.url": "EMAIL/LINK",
    "table.column.gender": "GENDER",
    "table.column.groups": "GROUPS",
    "table.column.id": "ID",
    "table.column.ignore": "IGNORE",
    "table.column.last.updated": "LAST UPDATED",
    "table.column.link": "LINK",
    "table.column.measure": "MEASURE",
    "table.column.name": "NAME",
    "table.column.name-from-search": "NAME FROM SEARCH",
    "table.column.name-on-match": "NAME ON MATCH",
    "table.column.national.id": "NATIONAL ID",
    "table.column.person": "PERSON",
    "table.column.pin": "PIN",
    "table.column.previous-search": "PREVIOUS SEARCH",
    "table.column.questions": "QUESTIONS",
    "table.column.required": "REQUIRED",
    "table.column.responsible-user": "RESPONSIBLE USER",
    "table.column.role": "ROLE",
    "table.column.search-by": "SEARCH BY",
    "table.column.shares": "SHARE",
    "table.column.status": "STATUS",
    "table.column.time-of-search": "TIME OF SEARCH",
    "table.column.title": "TITLE",
    "table.column.ubo": "OWNER",
    "table.column.used": "USED",
    "table.row.owner": "Shareholder",
    "tags.button.label": "Tags",
    "tags.editor.add-and-apply-button": "Add and apply «{tag}»",
    "tags.editor.existing-tags": "Existing tags",
    "tags.editor.filter-tags": "Filter tags:",
    "tags.editor.new-tag-input": "New tag",
    "tags.modal.empty-state": "There are currently no tags.",
    "tags.modal.tag.color": "Color",
    "tags.modal.tag.delete-tag": "Delete tag",
    "tags.modal.tag.delete-tag.description": "By deleting the tag «{name}» it is also removed from all projects and associated customers.",
    "tags.modal.tag.name": "Tag name in {language}",
    "tags.modal.tag.placeholder": "Tag name",
    "tags.modal.tag.validation-error": "Tag must be unique and not empty",
    "tags.modal.title.add-tag": "Add Tag",
    "tags.modal.title.edit-tags": "Edit Tags",
    "tags.modal.title.update-tag": "Edit Tag",
    "tags.page.assigned-tag.delete.description": "Assigned tag can not be deleted",
    "tags.page.filter.placeholder": "Filter tags by name",
    "tags.page.subtitle": "Create tags to easily group customers/clients. Tags can easily be added to any customer/client and filtered on both in the customer list and on the dashboard.",
    "tags.page.title": "Organize with tags",
    "tags.popover.success.message": "Assigned tag",
    "ubo.manual-override.description": "Changes should be justified in the comment field below.\n(You will have to change the screening manually if necessary, e.g. if new beneficial owners are to be screened)",
    "ubo.manual-override.title": "Person is ultimate beneficial owner (UBO)",
    "users.modal.empty-group": "No group",
    "users.modal.label.activate": "Activate",
    "users.modal.label.deactivate": "Deactivate",
    "users.modal.title.add-user": "Add User",
    "users.modal.title.update-user": "Update User",
    "users.page.add-user.button-label": "Add User",
    "users.page.filter.hide-inactive-users": "Hide inactive users ({count, number})",
    "users.page.filter.placeholder": "Filter users by name",
    "users.page.filter.show-inactive-users": "Show inactive users ({count, number})",
    "users.page.table.empty": "No users were found",
    "users.page.title": "Users",
    "vitec.modal.banner.description": "This person has no mobile phone number. Vitec Next requires the person's mobile number so that the contact card can be imported.",
    "vitec.modal.toast.message.error": "Failed to import {name} to Vitec Next ({error})",
    "vitec.modal.toast.message.success": "{name} was successfully imported to Vitec Next",
    "vitec.report.upload.status.COMPLETED": "Uploaded to Vitec",
    "vitec.report.upload.status.FAILED": "Upload failed",
    "vitec.report.upload.status.WAITING": "Awaiting review"
}
